import React, { useContext, useRef, useState } from "react";
import { FormInstance, Button, Form, Input } from "antd";
import { LoginUserType } from "api/interfaces";
import { stagingLogin } from "api/consumerLogin";
import classes from "./Login.module.css";
import StagingAuthContext from "context/StagingAuthContext";
import { useNavigate } from "react-router-dom";

export const StagingLoginForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<Omit<LoginUserType, "email">>({
    password: ""
  });
  const { setIsLoggedIn } = useContext(StagingAuthContext);

  const formRef = useRef<FormInstance>(null);

  const handleSignIn = async () => {
    setLoading(true);
    const response = await stagingLogin(formData);
    setLoading(false);

    setIsLoggedIn(response?.data);
  };

  return (
    <Form className="Form" onFinish={handleSignIn} ref={formRef}>
      <Form.Item>
        <Input.Password
          type="password"
          placeholder="Enter Master Password"
          value={formData.password}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              password: e.target.value
            }))
          }
        />
      </Form.Item>
      <Button
        loading={loading}
        disabled={loading}
        onClick={() => {
          formRef.current?.submit();
        }}
        style={{
          width: "100%",
          height: "56px",
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: "29px",
          textAlign: "center",
          borderRadius: "8px"
        }}
        htmlType="submit">
        Login
      </Button>
    </Form>
  );
};
